export const debounce = (func: (...args) => unknown, wait = 0) => {
  let timeout: NodeJS.Timeout;
  return function (...args: unknown[]) {
    const later = function () {
      timeout = null;
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
